<template>
    <rkm-area
        v-if="form && model"
        no-margin-top
        title="Identificação da viagem"
        type="section"
    >
        <rkm-form>
            <rkm-row>
                <rkm-col>
                    <rkm-form-date-picker
                        label="Data"
                        v-model="model.data"
                        :min-date="form.minDate"
                        :validations="validations.data"
                        @input="handleMunicipios"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        label="Município"
                        :options="form.municipios"
                        show-default-option
                        default-option-text="Todos"
                        text-field="nome"
                        value-field="id"
                        v-model="model.municipioId"
                        @change="handleLocais"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        label="Local da consulta"
                        :options="form.locais"
                        show-default-option
                        default-option-text="Todos"
                        text-field="descricao"
                        value-field="id"
                        v-model="model.destinoId"
                        @change="handleHorarios"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        label="Horario da consulta"
                        :options="form.horarios"
                        show-default-option
                        default-option-text="Todos"
                        text-field="horario"
                        value-field="horario"
                        v-model="model.horario"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click="search"
                        :disabled="!this.model.data"
                    >
                        Buscar
                    </rkm-button>
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click="handleClear"
                        :disabled="this.agendamentos.length == 0"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            v-if="agendamentos.length"
            :fields="fields"
            :items="agendamentos"
            hide-filters
            sort-by="id"
        >
            <template v-slot:cell(idade)="{ item }">
                {{ calcularIdade(item.dataNascimento) }}
            </template>
            <template v-slot:cell(novoHorario)="{ item, index }">
                <rkm-form-time-picker
                    v-model="item.novoHorario"
                    @input="handleNovoHorario(item.novoHorario, index)"
                />
            </template>
        </rkm-table>
    </rkm-area>
</template>

<script>
import { error, repository, stringCase } from "@/mixins";

import { mapActions } from "vuex";

import moment from 'moment';

export default {
    watch: {
        'model.municipioId': function(){
            this.handleLocais()
            this.handleHorarios()
        },
        'model.destinoId': function() {
            this.handleMunicipios()
            this.handleHorarios()
        },
        'model.horario': function() {
            this.handleMunicipios()
            this.handleLocais()
        },
    },
    computed: {
        validations() {
            return {
                data:  { required: true },
            }
        },
        fields() {
            return [
                {
                    name: "nome",
                    label: "Nome paciente",
                    key: "nome",
                },
                {
                    name: "prontuario",
                    label: "Pront.",
                    key: "prontuario",
                },
                {
                    name: "idade",
                    label: "Idade",
                    key: "idade",
                },
                {
                    name: "destino",
                    label: "Local consulta",
                    key: "destino",
                },
                {
                    name: "horarioSaida",
                    label: "Horário de saída",
                    key: "horarioSaida",
                },
                {
                    name: "horario",
                    label: "Horário da consulta",
                    key: "horario",
                },
                {
                    name: "ponto",
                    label: "Ponto",
                    key: "ponto",
                },
                {
                    name: "novoHorario",
                    label: "Novo horário",
                    key: "novoHorario",
                },
            ];
        },
    },
    data: () => {
        return {
            form: null,
            model: null,
            agendamentos: [],
        };
    },
    created() {
        this.repositories = {
            agendar: this.getConectaSusRepository("transportePaciente.agendar"),
        };
        this.load()
    },
    methods: {
        ...mapActions([ 'setLoading', 'unsetLoading' ]),
        calcularIdade(dataNascimento) {
            return moment().diff(dataNascimento, 'years')
        },
        resetOptions() {
            if(!this.form.municipios.find(municipio => municipio.id == this.model.municipioId)){
                this.model.municipioId = null
            }
            if(!this.form.locais.find(local => local.id == this.model.destinoId)){
                this.model.destinoId = null
            }
            if(!this.form.horarios.find(item => item.horario == this.model.horario)){
                this.model.horario = null
            }

        },
        handleMunicipios() {
            if(this.model.data) {
                this.setLoading()
                this.repositories.agendar.getMunicipios({
                    'data': moment(this.model.data).format('YYYY-MM-DD'),
                    'destino_id': this.model.destinoId,
                    'horario': this.model.horario,
                })
                    .then(({data}) => {
                        this.form.municipios = data
                        this.resetOptions()
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handleLocais() {
            if(this.model.data) {
                this.setLoading()
                this.repositories.agendar.getLocais({
                    'data': moment(this.model.data).format('YYYY-MM-DD'),
                    'municipio_id': this.model.municipioId,
                    'horario': this.model.horario,
                })
                    .then(({data}) => {
                        this.form.locais = data
                        this.resetOptions()
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handleHorarios() {
            if(this.model.data) {
                this.setLoading()
                this.repositories.agendar.getHorarios({
                    'data': moment(this.model.data).format('YYYY-MM-DD'),
                    'municipio_id': this.model.municipioId,
                    'destino_id': this.model.destinoId,
                })
                    .then(({data}) => {
                        this.form.horarios = data
                        this.resetOptions()
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        search() {
            if(!this.model.data) {
                this.showAlert('Data inválida.','Atenção')
            }
            else {
                this.setLoading()
                this.repositories.agendar.getAgendamentos({
                    'data': moment(this.model.data).format('YYYY-MM-DD'),
                    'municipio_id': this.model.municipioId,
                    'destino_id': this.model.destinoId,
                    'horario': this.model.horario,
                })
                    .then(({data}) => this.agendamentos = data)
                    .catch(this.handleError)
                    .finally(() => {
                        this.unsetLoading()
                        if(this.agendamentos.length == 0) {
                            this.showAlert('Não existe agendamento para essa o periodo selecionado.', 'Atenção')
                        }
                    })
            }
        },
        handleNovoHorario(novoHorario, index) {
            if(moment(novoHorario, 'HH:mm').isAfter(moment(this.agendamentos[index].horario, 'HH:mm'))){
                this.showAlert('Novo horario não pode ser superior ao horario da consulta.', 'Atenção')
                this.agendamentos[index].novoHorario = null
            }
        },
        handleClear() {
            this.agendamentos = []
            this.model.data = null
            this.model.municipioId = null
            this.model.destinoId = null
            this.model.horario = null
            this.form.municipios = []
            this.form.locais = []
            this.form.horarios = []
        },
        save() {
            if(this.agendamentos.every(agendamento => agendamento.novoHorario == null ||agendamento.novoHorario == '')) {
                this.showAlert('Nenhum novo horario para ser salvo.', 'Atenção')
            } else {
                this.setLoading()
                this.repositories.agendar
                .updateHorario(
                    this.camelObjectKeysToSnakeRecursive({
                        'agendamentos' : this.agendamentos.filter(agendamento => agendamento.novoHorario)
                    }))
                    .then(() => {
                        this.showSaveNotification()
                        this.search()
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
                }
        },
        load(){
            this.setLoading()
            this.repositories.agendar.editHorario()
                .then(({data}) => {
                    this.setData(data.form, data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setData(form, model) {
            if(form) {
                this.form = Object.assign(form)
            }
            if(model) {
                this.model = Object.assign(model)
            }
        },
    },
    mixins: [error, repository, stringCase],
};
</script>
